import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import store from './views/article/src/store'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

import filters from './views/article/src/filters'
// import LogFlow from './utils/logFlow'

// 移动端滑动插件
import pluginTouch from 'gkui/swipe'

// 模式弹出插件
import ModalPlugin from 'gkui/modal'
// Message插件
import MessagePlugin from 'gkui/message/index'

import VueScrollTo from 'vue-scrollto'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// 滑动组件
Vue.use(pluginTouch)

// 模式弹出
Vue.use(ModalPlugin)

Vue.use(MessagePlugin)

// Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollTo)
// 日志上报
// Vue.use(LogFlow, {
//   logstore: 'infoq_web', // 需要根据具体的业务选择对应的 logstore
//   lfDomain: '.infoq.cn'
// })

// 设置过滤器
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
